import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import useGetApp from "src/hooks/useGetApp";
import useGetOrg from "src/hooks/useGetOrganization";
import useLocales from "src/hooks/useLocales";
import { useUpdateAppRequest } from "src/services/organizations/commands/app";
import { AppType } from "src/types/apps";
import SnackbarUtils from "src/utils/SnackbarUtils";

const useUpdateForceApi = () => {
	const [isLoading, setIsLoading] = useState(false);

	const { id } = useGetOrg();
	const app = useGetApp();
	const queryClient = useQueryClient();
	const { translate } = useLocales();

	const { mutate } = useUpdateAppRequest();

	const onSuccess = (forceSecureConnection: boolean) => {
		setIsLoading(false);
		SnackbarUtils.success(translate("app_settings.update_app_success"));
		queryClient.setQueryData(["apps"], (old: AppType[]) =>
			old.map((i) => {
				if (i.id === app?.id) return { ...i, forceSecureConnection };
				return i;
			})
		);
	};

	const onError = () => {
		setIsLoading(false);
		SnackbarUtils.error(translate("app_settings.update_app_error"));
	};

	const updateApp = (forceSecureConnection: boolean) => {
		setIsLoading(true);
		mutate(
			{ orgId: id, appId: app?.id ?? "", name: app?.name ?? "", forceSecureConnection },
			{ onSuccess: () => onSuccess(forceSecureConnection), onError }
		);
	};

	return { updateApp, isLoading };
};

export default useUpdateForceApi;
